import { render } from "./TherapyScheduleManagement.vue?vue&type=template&id=487a6683&scoped=true"
import script from "./TherapyScheduleManagement.vue?vue&type=script&lang=js"
export * from "./TherapyScheduleManagement.vue?vue&type=script&lang=js"

import "./TherapyScheduleManagement.vue?vue&type=style&index=0&id=487a6683&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487a6683"]])

export default __exports__